import React,{useState} from 'react'
import './MaskIcon.css'

const MaskIcon = (props)=>{
    const [passwordMask, setPasswordMask] = useState(true)
    return <div onClick={() => {
        setPasswordMask(props.passwordRef.current.state.unmasked)
        props.passwordRef.current.onMaskToggle()
      }} className="mask-show">{passwordMask ? 'Show' : 'Hide'}</div>
}

export default MaskIcon